<div class="block--content block">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <div class="block__left-side-panel">
                <div class="text-items">
                    <p class="text-items__title">
                        {{ 'ADD_POWER_USER_TITLE' | translate }}
                    </p>

                    <p class="text-items__description">
                        <span>{{ 'ADD_POWER_USER_DESC' | translate }}</span>
                    </p>
                </div>
            </div>

            <div class="block__right-side-panel">
                <div class="block-full-width no-padding no-border-radius">
                    <div class="card-details">
                        <div class="card-details-area">
                            <p class="card-details-area__title">
                                {{ 'POWER_USER_DETAILS' | translate }}
                            </p>
                            <form [formGroup]="powerUserForm" (ngSubmit)="addUser()">
                                <div class="card-details-area__card-number">
                                    <ridango-form-field>
                                        <input
                                            [formControl]="powerUserForm.controls.email"
                                            ridangoInput
                                            name="email"
                                            required />
                                        <ridango-label>{{ 'PH_EMAIL' | translate }} </ridango-label>
                                        <ridango-error *ngIf="powerUserForm.controls.email.hasError('required')">
                                            {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                        </ridango-error>
                                        <ridango-error *ngIf="powerUserForm.controls.email.hasError('email')">
                                            {{ 'EMAIL_NOT_VALID' | translate }}
                                        </ridango-error>
                                    </ridango-form-field>
                                </div>

                                <button
                                    class="btn btn--maximal btn--primary btn--big"
                                    [disabled]="powerUserForm.invalid"
                                    type="submit">
                                    {{ 'BTN_USER_DETAILS' | translate }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
